import { render, staticRenderFns } from "./systemLog.vue?vue&type=template&id=3618d562&"
import script from "./systemLog.vue?vue&type=script&lang=js&"
export * from "./systemLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports